import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loader from './components/Loader'; 
import ScrollToTop from './components/ScrollToTop';

// pages
import Home from './pages/Home';
import News from './pages/News';
import Booking from './pages/Booking';
import ThankYou from './pages/ThankYou';
import About from './pages/About';
import Services from './pages/Service';
import FAQs from './pages/FAQs';
import Career from './pages/Career';
import Contact from './pages/Contact';
import NewsDetail from './pages/NewsDetail';
import Gallery from './pages/Gallery';

// services
import HomeCleaning from './pages/services/HomeCleaning';
import CommercialCleaning from './pages/services/CommercialCleaning';
import AirbnbCleaning from './pages/services/AirbnbCleaning';
import CarpetCleaning from './pages/services/CarpetCleaning';
import AfterBuildersCleaning from './pages/services/AfterBuildersCleaning';
import { LoadScript } from "@react-google-maps/api";

function App() {
  const [loading, setLoading] = useState(true);
  const GOOGLE_API_KEY = "AIzaSyDGtafPM4wX75Nv4HZBQKga6_zEyQT-zB4";
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); // Adjust delay as needed
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

<LoadScript
  googleMapsApiKey={GOOGLE_API_KEY}
  libraries={["places"]}
>
  <Booking />
</LoadScript>

  return (
    <>
    <ScrollToTop />
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/news" element={<News />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/residential-cleaning" element={<HomeCleaning />} />
      <Route path="/services/commercial-cleaning" element={<CommercialCleaning />} />
      <Route path="/services/airbnb-cleaning" element={<AirbnbCleaning />} />
      <Route path="/services/carpet-cleaning" element={<CarpetCleaning />} />
      <Route path="/services/after-builder-&-open-home-cleaning" element={<AfterBuildersCleaning />} />
      <Route path="/FAQs" element={<FAQs />} />
      <Route path="/career" element={<Career />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/news/:id" element={<NewsDetail />} />
      <Route path="/gallery" element={<Gallery />} />
    </Routes>
    <Footer />
  </>
  );
}

export default App;
